import React from 'react';
import { useWidgetManager } from '@/contexts/WidgetManager';
import { Widget } from './widget';
import { WeatherWidget } from '@/components/widgets/WeatherWidget';
import { ClockWidget } from '@/components/widgets/ClockWidget';

const widgetComponents = {
  weather: WeatherWidget,
  clock: ClockWidget,
};

export const WidgetContainer: React.FC = () => {
  const { widgets } = useWidgetManager();

  const visibleWidgets = widgets.filter(widget => widget.visible);

  if (visibleWidgets.length === 0) {
    return null;
  }

  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      {visibleWidgets.map((widget) => {
        const WidgetComponent = widgetComponents[widget.type as keyof typeof widgetComponents];
        
        if (!WidgetComponent) {
          console.warn(`Widget component not found for type: ${widget.type}`);
          return null;
        }

        return (
          <Widget
            key={widget.id}
            id={widget.id}
            position={widget.position}
            zIndex={widget.zIndex}
          >
            <WidgetComponent />
          </Widget>
        );
      })}
    </div>
  );
};